import { render, staticRenderFns } from "./Affiliation.vue?vue&type=template&id=5a3be8cb&scoped=true"
import script from "./Affiliation.vue?vue&type=script&lang=js"
export * from "./Affiliation.vue?vue&type=script&lang=js"
import style0 from "./Affiliation.vue?vue&type=style&index=0&id=5a3be8cb&prod&lang=stylus&scoped=true"
import style1 from "./Affiliation.vue?vue&type=style&index=1&id=5a3be8cb&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3be8cb",
  null
  
)

export default component.exports